export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20warm%20toned%20manga%20comic%20illustration%20background%20with%20soft%20floating%20panels%20and%20subtle%20ink%20textures%2C%20warm%20amber%20and%20cream%20gradients%2C%20minimalist%20Japanese%20comic%20aesthetic%2C%20clean%20atmospheric%20backdrop%20with%20gentle%20color%20washes%20and%20floating%20manga%20page%20motifs&width=1600&height=900&seq=hero-bg-manga&orientation=landscape"
          alt="5151漫画网背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/35 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
              <span className="px-3 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full whitespace-nowrap">
                51漫画下载
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full whitespace-nowrap">
                免费全集离线看
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-4">
              5151漫画网 · 高清漫画免费下载与离线阅读平台
            </h1>

            <p className="text-lg md:text-xl text-background-50/80 font-heading mb-5">
              随时随地，畅享无网络阅读
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              5151漫画网汇聚海量日漫、国漫、韩漫高清资源，支持51漫画免费版下载和离线缓存功能，一键批量下载全集，轻松将热门连载漫画永久收藏至本地。
              无论您在地铁、航班还是偏远地区，无需网络也能畅享极致阅读体验。本站每日更新最新话数与完结作品，
              涵盖热血、恋爱、悬疑、搞笑、奇幻等全品类题材，是51漫画下载爱好者的首选资源站。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-background-50/90">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-database-2-line text-primary-400 text-lg"></i>
                </div>
                <span className="text-sm font-medium whitespace-nowrap">10000+ 漫画资源</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/90">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-refresh-line text-accent-400 text-lg"></i>
                </div>
                <span className="text-sm font-medium whitespace-nowrap">每日持续更新</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/90">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-download-cloud-2-line text-secondary-400 text-lg"></i>
                </div>
                <span className="text-sm font-medium whitespace-nowrap">高速离线下载</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all whitespace-nowrap cursor-pointer text-center"
              >
                立即浏览漫画合集
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-semibold text-sm rounded-full border border-background-50/30 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                下载51漫画客户端
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20manga%20collection%20display%20with%20floating%20comic%20book%20covers%20in%20warm%20amber%20and%20coral%20tones%2C%20Japanese%20manga%20style%20illustrations%20arranged%20in%20a%20dynamic%20cascading%20layout%2C%20soft%20dramatic%20lighting%2C%20clean%20minimal%20composition%20with%20rich%20color%20gradients%2C%20modern%20editorial%20design%20aesthetic&width=800&height=600&seq=hero-main-manga&orientation=landscape"
                alt="5151漫画网 - 高清漫画资源精选展示"
                className="w-full h-full object-cover object-center rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1 text-xs font-medium bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full whitespace-nowrap">
                  51漫画免费版下载 · 全集离线看
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}